import styled from "styled-components";

export const Wrapper = styled.div`
  canvas {
    width: 100% !important;
  }
`;

export const BsrModalContent = styled.div`
  canvas {
    width: 100% !important;
  }

  .bsr-stat-card.ant-card {
    flex: 1;
    min-width: 180px;
    border-radius: 8px;
    border: 1px solid var(--app-border);
  }

  .bsr-stat-card .ant-card-body {
    padding: 8px 12px !important;
  }

  .bsr-stat-card--sub.ant-card {
    background: color-mix(in srgb, #314f71 10%, var(--app-surface)) !important;
    border-left: 3px solid #314f71 !important;
  }

  .bsr-stat-card--root.ant-card {
    background: color-mix(in srgb, #f45b68 10%, var(--app-surface)) !important;
    border-left: 3px solid #f45b68 !important;
  }

  .bsr-stat-label {
    color: var(--app-text-muted);
    font-size: 0.8rem;
    margin-bottom: 0.25rem;
  }

  .bsr-stat-value--sub {
    color: #314f71;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.2;
  }

  .bsr-stat-value--root {
    color: #f45b68;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.2;
  }

  .bsr-chart-wrap {
    min-height: 400px;
  }

  .bsr-details-summary {
    color: var(--app-text);
    cursor: pointer;
    font-size: 0.95rem;
  }

  .bsr-table-wrap {
    max-height: 300px;
    overflow: auto;
    margin-top: 12px;
    border: 1px solid var(--app-border);
    border-radius: 8px;
    background: var(--app-surface);
  }

  .bsr-table {
    font-size: 12px;
    margin-bottom: 0;
    color: var(--app-text);
  }

  .bsr-table thead {
    position: sticky;
    top: 0;
    background: var(--app-surface-alt);
    z-index: 1;
  }

  .bsr-table thead th {
    color: var(--app-text);
    border-bottom-color: var(--app-border);
    font-weight: 600;
  }

  .bsr-table tbody td {
    border-bottom-color: var(--app-border-soft, var(--app-border));
    color: var(--app-text);
  }

  .bsr-table tbody tr:hover td {
    background: var(--app-surface-alt);
  }

  .bsr-rank--sub {
    color: #314f71;
    font-weight: 600;
  }

  .bsr-rank--root {
    color: #f45b68;
    font-weight: 600;
  }

  [data-bs-theme="dark"] & {
    .bsr-stat-card--sub.ant-card {
      background: color-mix(in srgb, #6ea8fe 14%, var(--app-surface)) !important;
      border-left-color: #6ea8fe !important;
    }

    .bsr-stat-card--root.ant-card {
      background: color-mix(in srgb, #f45b68 16%, var(--app-surface)) !important;
    }

    .bsr-stat-value--sub {
      color: #8eb8e8;
    }
  }
`;
